function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

var _ref2 = /*#__PURE__*/React.createElement("rect", {
  x: 0.5,
  width: 40,
  height: 40,
  rx: 16,
  fill: "#FAC7D2"
});

var _ref3 = /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M27.7727 16.6364H25.0455V13H12.3182C11.3182 13 10.5 13.8182 10.5 14.8182V24.8182H12.3182C12.3182 26.3273 13.5364 27.5455 15.0455 27.5455C16.5545 27.5455 17.7727 26.3273 17.7727 24.8182H23.2273C23.2273 26.3273 24.4455 27.5455 25.9545 27.5455C27.4636 27.5455 28.6818 26.3273 28.6818 24.8182H30.5V20.2727L27.7727 16.6364ZM27.3182 18L29.1 20.2727H25.0454V18H27.3182ZM14.1363 24.8182C14.1363 25.3182 14.5454 25.7273 15.0454 25.7273C15.5454 25.7273 15.9545 25.3182 15.9545 24.8182C15.9545 24.3182 15.5454 23.9091 15.0454 23.9091C14.5454 23.9091 14.1363 24.3182 14.1363 24.8182ZM17.0637 23C16.5637 22.4454 15.8546 22.0909 15.0455 22.0909C14.2364 22.0909 13.5273 22.4454 13.0273 23H12.3182V14.8182H23.2273V23H17.0637ZM25.0454 24.8182C25.0454 25.3182 25.4545 25.7273 25.9545 25.7273C26.4545 25.7273 26.8636 25.3182 26.8636 24.8182C26.8636 24.3182 26.4545 23.9091 25.9545 23.9091C25.4545 23.9091 25.0454 24.3182 25.0454 24.8182Z",
  fill: "#121221"
});

function SvgLogistics(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, ["title", "titleId"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 41,
    height: 40,
    viewBox: "0 0 41 40",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _ref2, _ref3);
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogistics);
export default __webpack_public_path__ + "static/media/Logistics.8d9ac436.svg";
export { ForwardRef as ReactComponent };